var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#FCFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.625 21C33.625 14.5781 28.4219 9.375 22 9.375C15.5781 9.375 10.375 14.5781 10.375 21C10.375 26.8125 14.5938 31.6406 20.1719 32.4844V24.375H17.2188V21H20.1719V18.4688C20.1719 15.5625 21.9062 13.9219 24.5312 13.9219C25.8438 13.9219 27.1562 14.1562 27.1562 14.1562V17.0156H25.7031C24.25 17.0156 23.7812 17.9062 23.7812 18.8438V21H27.0156L26.5 24.375H23.7812V32.4844C29.3594 31.6406 33.625 26.8125 33.625 21Z",
    fill: "#45B549"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.16c6f197dbb129b2908270f44c155ac2.svg";
export { ForwardRef as ReactComponent };